// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"19":"header","177":"home","327":"authorization","983":"report"}[chunkId] + "." + {"19":"be562307","177":"1f78c1b2","327":"ed4174e7","983":"d20841df"}[chunkId] + ".chunk.css";
};